import React from 'react';

import { TUser } from './../services/http/User';

const UserProvider = React.createContext<[TUser, any]>([
  // @ts-ignore
  {}, {}
]);

export default UserProvider;